<template>
  <div style="background-color: #F5F7FA;height: 100%;">
    <div style="padding: 20px;">
      <template>
        <el-col :span="24" style="padding:5px 0">
          <el-col :span="20">
            <Daterange :startTime="startTime"  is-datetime="datetime" :endTime="endTime" @dataChange='dataChange'></Daterange>
          </el-col>
          <el-col :span="4"  >
            <el-button style="float: right;" size="mini" type="primary" @click="submit">搜索</el-button>
          </el-col>
        </el-col>

        <el-table v-loading="tableLoading"  :data="tableData" :height="300" border style=" max-height: 500px ;overflow-y: auto;overflow-x: auto ">
          <el-table-column prop="advice" width="300" label="健康建议" ></el-table-column>

          <el-table-column prop="sober" width="150"  label="清醒时长 （分钟）" ></el-table-column>
          <el-table-column prop="lightSleep" width="150"  label="浅睡时长 （分钟）" ></el-table-column>
          <el-table-column prop="deepSleep" width="150" label="深睡时长 （分钟）"></el-table-column>
          <el-table-column prop="sleepHours" width="180"  label="睡眠总时长 （分钟）" ></el-table-column>
          <el-table-column prop="sleepQuality" width="100" label="睡眠质量" ></el-table-column>
          <el-table-column prop="respiratoryRate" width="130"  label="平均呼吸频率" ></el-table-column>
          <el-table-column prop="heartRate"  label="平均心率" width="180" ></el-table-column>
          <el-table-column prop="bodyMove"  label="体动次数" width="180" ></el-table-column>
          <el-table-column prop="bedAway"  label="离床次数" width="180" ></el-table-column>
          <el-table-column prop="abnormal"  label="异常次数" width="180" ></el-table-column>

          <el-table-column prop="addTime" :formatter="getAddTime" width="180"  label="生成时间" ></el-table-column>
          <el-table-column prop="startBedTime" :formatter="getStartBedtime" width="180"  label="上床时间" ></el-table-column>
          <el-table-column prop="endBedTime" :formatter="getEndBedtime"  width="180" label="离床时间" ></el-table-column>
          <el-table-column prop="sleepTime"  :formatter="getSleepTime" width="180" label="入睡时间" ></el-table-column>


        </el-table>
        <div style="text-align: left;background-color: #fff;padding: 10px;">
          <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
          <div style="float: left;">
            <el-pagination
                background
                layout="prev, pager, next"
                :total="totalItems"
                :page-size="20"
                :current-page.sync="currentPage"  @current-change="current_change">
            </el-pagination>
          </div>
          <div style="clear: both;"></div>
        </div>


      </template>
    </div>
  </div>
</template>

<script>


import {timefilters, timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";
import Daterange from "@/components/Daterange";

export default {
  name: "SleepQualityPage",
  data() {
    return {
      tableLoading:false,
      userCode: '',
      pageIndex:'',
      tableData:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,
      startTime:'',
      endTime:''
    }
  },
  components: {
    Daterange
  },

  methods: {
    init(userCode) {
      this.userCode = userCode;
      this.endTime=timefilters(new Date())
      this.startTime=timefilters(new Date(new Date()-1000 * 60 * 60 * 24 * 7))
      this.getSleepQualityPage();
    },
    dataChange(val){
      this.startTime=val[0]
      this.endTime=val[1]
    },
    closeSelf() {
      this.$emit("closeSleepQualityPage");
    },
    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getSleepQualityPage();
    },
    submit(){
      this.getSleepQualityPage();
    },
    getAddTime(row){
      return timefilters(row.addTime)
    },
    getStartBedtime(row){
      return timefilters(row.startBedTime)
    },
    getEndBedtime(row){
      return timefilters(row.endBedTime)
    },
    getSleepTime(row){
      return timefilters(row.sleepTime)
    },

    getSleepQualityPage(){
      this.tableLoading=true
      this.$axios({
        method: 'post',
        url: this.$deviceUrl + "SBJ/GetSleepReport",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          userCode: this.userCode,
          startTime:this.startTime,
          endTime:this.endTime,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then(
          (response) => {
            this.tableLoading=false
            if (response.data.error === 0) {
              this.tableData=response.data.data.list;
              this.totalItems=response.data.data.total;
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )

    },




  }


}
</script>

<style lang="scss" scoped>

</style>
